import { Link as RouterLink, Outlet } from 'react-router-dom';
import { Box, Card, Container, Typography } from '@mui/material';

// Layout simple centrado para login / registro / recuperar contrasena
export default function AuthLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        py: 6,
      }}
    >
      <Container maxWidth="xs">
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography
            variant="h4"
            component={RouterLink}
            to="/"
            sx={{ color: 'primary.main', textDecoration: 'none' }}
          >
            PalaciComputers
          </Typography>
        </Box>
        <Card sx={{ p: 4 }}>
          <Outlet />
        </Card>
      </Container>
    </Box>
  );
}
